/*
 * =============================================================================
 * Project: payments.telestrada-online.pl
 * Created Date: 2018-07-20, 13:08:33
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-07-20, 14:31:17
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import { API_TOKEN_STORAGE } from '@/config';

export default class ManageTokenService {
  static addTokenToStorage(token) {
    API_TOKEN_STORAGE.setItem('token', token);
  }

  static removeTokenFromStorage() {
    API_TOKEN_STORAGE.clear();
  }

  static getTokenFromStorage() {
    return API_TOKEN_STORAGE.getItem('token');
  }
}



// WEBPACK FOOTER //
// ./src/services/ManageTokenService.js